import { DeleteOutlined, EditOutlined, FileTextOutlined, FolderOpenOutlined, ToTopOutlined } from '@ant-design/icons';
import { Col, Form, Row, Card, Typography, Divider, Button, Tag, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AddCandidateButton from '../Common/AddCandidateButton';
import CandidateFields from '../Common/CandidateFields';
import MainDataFields from '../Common/MainDataFields';
import SalaryFields from '../Common/SalaryFields';
import SubmitButton from '../Common/SubmitButton';
import AddCandidateModal from './AddCandidateModal';
import { setApplicationById } from './getApplicationDataById';
import { IFetchedApplicationById } from './interface';
import SetupFields from './SetupFields';
import updateForm from './updateForm';
import './index.scss';
import api from '../services/api';

const { Title } = Typography;

function ApplicationRecruiting(props) {
  const [componentDisabled, setComponentDisabled] = useState<boolean>(true);
  const [isOpenCandidateModal, setIsOpenCandidateModal] =
    useState<boolean>(false);
  const [fetchApplicationById, setFetchApplicationById] =
    useState<IFetchedApplicationById>();

  const [tagColor, setTagColor] = useState<string>('blue');
  const [isArchived, setIsArchived] = useState<boolean>(false);
  const [applicationTabSelected, setApplicationTabSelected] = useState<boolean>(true);
  const [candidatesTabSelected, setCandidatesTabSelected] = useState<boolean>(false);
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const [candidates, setCandidates] = useState<any>([]);
  
  const { id } = useParams();
  const { title } = props;


  const [form] = Form.useForm();

  const navigate = useNavigate();


  const getCandidates = async (id: number) => {
    const { data } = await api.getDutyCandidatesById(id);
		  return data;
	};

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    if (id) {
      setApplicationById(Number(id), setFetchApplicationById);
    }
  }, [id]);

  useEffect(() => {
    if (fetchApplicationById) {
      const id = fetchApplicationById?.name_of_post_id?.id;
      getCandidates(id).then((values) => setCandidates(values));
    }
  }, [fetchApplicationById]);

  useEffect(() => {
    if (fetchApplicationById) {
      const status = fetchApplicationById?.application_status?.name;
      switch(status) {
        case 'Открыто':
        case 'Открыта':
          setTagColor('green');
          setIsArchived(false);
          break;
        case 'Закрыто':
        case 'Закрыта':
          setTagColor('red');
          setIsArchived(false);
          break;
        case 'Архивирована':
          setTagColor('purple');
          setIsArchived(true);
          break;
      }
    }
  }, [fetchApplicationById]);

  const onFormLayoutChange = ({ disabled }: { disabled: boolean }) => {
    setComponentDisabled(disabled);
  };

  const showModalMethod = () => {
    setIsOpenCandidateModal(true);
  };

  const checkReminderAndQuantityAmount = () => {
    if (fetchApplicationById) {
      return (
        Number(fetchApplicationById?.quantity_people) ===
        Number(fetchApplicationById?.reminder_quantity_people)
      );
    }
  };

  const checkPermission = () => {
    if (fetchApplicationById) {
      return fetchApplicationById.permission === true;
    }
  };

  const checkPermissionDirector = () => {
    if (fetchApplicationById) {
      return fetchApplicationById.dir_permission === true;
    }
  };

  const handleUpdateApplication = async (id: string, status: number) => {
    try {
      setUpdateLoading(true);
      const response = await api.updateApplicationById(id, { application_status: status });
      const successStatuses =
        response.status === 200 && response.statusText.toLowerCase() === 'ok';
      if (successStatuses) {
        setUpdateLoading(false);
        if (id) {
          setApplicationById(Number(id), setFetchApplicationById);
        }
      } 
      else {
        setUpdateLoading(false);
        throw new Error('Попробуйте еще раз');
      }
    } catch (error: any) {
      setUpdateLoading(false);
      notification.info({
        message: 'Ошибка',
        description: error.message,
      });
    }
  };

  const handleRemoveCandidate = async (candidateId: number) => {
    try {
      const response = await api.deleteCandidate(candidateId);
      const successStatuses =
        response.status === 200 && response.statusText.toLowerCase() === 'ok';
      if (successStatuses) {
        if (id) {
          setApplicationById(Number(id), setFetchApplicationById);
        }
      }  else {
        throw new Error('Попробуйте еще раз');
      }
    } catch (error: any) {
      notification.info({
        message: 'Ошибка',
        description: error.message,
      });
    }
  };

  return (
    <>
      <Card style={{ marginTop: 25, marginBottom: 400 }}>
        <Row style={{marginBottom: '15px'}}>
          <Col xs={9} sm={12}  >
            <Button
              onClick={() => {
                navigate(-1);
              }}
              type="default"
            >
              Назад
            </Button>
          </Col>

          <Col xs={15} sm={12} style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
              <Tag 
                color={tagColor}
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  padding: '5px 25px',
                  margin: '0'
                }}
              >
                {fetchApplicationById?.application_status?.name}
              </Tag>
          </Col>
        </Row>

        <Row style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
          
            { isArchived ?
              <Button
                type='primary'
                className='application-update-btn'
                loading={updateLoading}
                onClick={
                  () => {
                    if (id) {
                      handleUpdateApplication(id, 7621); // Статус 7621 - Открыта/active
                    }
                  }
                }
              >
                <ToTopOutlined /> Восстановить
              </Button>
              : 
              <Button
                type='primary'
                className='application-update-btn'
                loading={updateLoading}
                onClick={
                  () => {
                    if (id) {
                      handleUpdateApplication(id, 8548); // Статус 8549 - Архивирована/archived
                    }
                  }
                }
              >
                <FolderOpenOutlined /> Архивировать
              </Button>
            }
           
        </Row>

        <Row>
          <Col xs={24} sm={12}>
            <div 
              className={applicationTabSelected ? 'application-tab-selected' : 'application-tab'}
              onClick={() => {
                setApplicationTabSelected(true);
                setCandidatesTabSelected(false);
              }}
            >
              <p style={{margin: '0'}}>
                Заявка на поиск кандидата
              </p>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div 
              className={candidatesTabSelected ? 'application-tab-selected' : 'application-tab'}
              onClick={() => {
                setCandidatesTabSelected(true);
                setApplicationTabSelected(false);
              }}
            >
              <p style={{margin: '0'}}>
                Кандидаты
              </p>
            </div>
          </Col>
        </Row>

        { applicationTabSelected ?
          <div>
            <Form
              layout="vertical"
              validateMessages={{ required: 'Обязательное поле для заполнения' }}
              name="applicationExisting"
              onValuesChange={onFormLayoutChange}
              disabled={componentDisabled}
              form={form}
              onFinish={(values) => {
                updateForm(id, values);
              }}
              style={{ fontWeight: 'initial' }}
            >
              

              <MainDataFields disabled={componentDisabled} />

              <Divider />

              <Title level={4} style={{ color: '#0057FF', marginBottom: 30 }}>
                Оплата труда
              </Title>

              <SalaryFields />

              <CandidateFields />
            </Form>
            

            {componentDisabled === true ? (
              <>
                {checkReminderAndQuantityAmount() === false &&
                checkPermission() === true ? (
                  <Row gutter={24} align="bottom">
                    <Col xs={24} xl={8}>
                      <AddCandidateButton showModalMethod={showModalMethod} />
                    </Col>
                    <Col xs={24} xl={{ span: 8, offset: 8 }}>
                      <Button
                        block
                        icon={<EditOutlined />}
                        onClick={() => {
                          setComponentDisabled((prevValue) => !prevValue);
                        }}
                        type="primary"
                      >
                        Изменить
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  checkPermission() === true && (
                    <Col xs={24} xl={{ span: 8, offset: 16 }}>
                      <Button
                        block
                        icon={<EditOutlined />}
                        onClick={() => {
                          setComponentDisabled((prevValue) => !prevValue);
                        }}
                        type="primary"
                      >
                        Изменить
                      </Button>
                    </Col>
                  )
                )}
              </>
            ) : (
              <>
                {checkPermission() === true ? (
                  <Row gutter={24}>
                    <Col xs={24} xl={8}>
                      <AddCandidateButton showModalMethod={showModalMethod} />
                    </Col>
                    <Col xs={24} xl={{ span: 8, offset: 8 }}>
                      <SubmitButton
                        buttonText="Сохранить"
                        onClick={() => {
                          form.submit();
                        }}
                      />
                    </Col>
                  </Row>
                ) : (
                  checkPermissionDirector() === true && (
                    <Col xs={24} xl={{ span: 8, offset: 16 }}>
                      <SubmitButton
                        buttonText="Сохранить"
                        onClick={() => {
                          form.submit();
                        }}
                      />
                    </Col>
                  )
                )}
              </>
            )}
          </div> : ''}

        {candidatesTabSelected ?
          <div className='application-candidates-main'>
            <div className='application-candidates-list'>
              {candidates.length !== 0 ? 
                <div>
                  {candidates.map((candidate, index) => (
                    <Row key={index} className='application-candidate-card'>
                      <Col sm={24} md={10} style={{marginBottom: '5px', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <p style={{margin: '0', marginRight: '5px', color: '#0057FF', fontSize: '16px', fontWeight: '500'}}>{index + 1}  |</p>
                        <p style={{margin: '0', fontSize: '16px', fontWeight: '500'}}>{candidate?.id}. {candidate?.candidate_fullname}</p>
                      </Col>
                      
                      <Col xs={24} sm={16} md={11} style={{display: 'flex', justifyContent: 'center', marginBottom: '5px'}}>
                        <Button 
                          style={{width: '300px', textAlign: 'center'}}
                          onClick={() => {
                            navigate(`/recruiting/position-candidate/${candidate?.id}`);
                          }}
                        >
                          <FileTextOutlined /> Открыть резюме
                        </Button>
                      </Col>
                      <Col xs={24} sm={8} md={3} style={{display: 'flex', justifyContent: 'center', marginBottom: '5px'}}>
                        <Button 
                          style={{width: '130px'}}
                          onClick={() => {
                            handleRemoveCandidate(candidate?.id);
                          }}
                        >
                          <DeleteOutlined /> Удалить
                        </Button>
                      </Col>
                  </Row>
                  ))}
                </div>
              :
              <div style={{display: 'flex', justifyContent: 'center', height: '300px'}}><h3>Кандидаты отсутствуют</h3></div>
              }
              
            </div>
          </div> 
        : ''}
        
      </Card>
      <AddCandidateModal
        isOpenCandidateModal={isOpenCandidateModal}
        setIsOpenCandidateModal={setIsOpenCandidateModal}
        fetchApplicationById={fetchApplicationById}
      />
      {fetchApplicationById && (
        <SetupFields fetchApplicationById={fetchApplicationById} form={form} />
      )}
    </>
  );
}

export default ApplicationRecruiting;
